export function LoginTopSpacer(): React.ReactElement {
  return (
    <div className="mt-5 h-[75px] w-full max-w-[400px]" aria-hidden="true" data-testid="login-top-spacer" />
  );
}
